import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef8a38c6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ef8a38c6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=ef8a38c6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8a38c6",
  null
  
)

export default component.exports